// Share-card A/B (`card-ab-v1`) — client half (TECH_SPEC §4bis.20).
//
// The client's only job in this experiment is to stamp the arm on the share URL
// so the resulting `link_open` can be split by it. It does NOT choose the card:
// the card is rendered server-side from the same rule, so a link forwarded by a
// third party still shows the arm its owner was assigned.
//
// MIRROR: `packages/server/src/experiment.ts` implements the identical rule
// (client and server never import each other). Both sides are pinned by the
// same golden vector in their test suites; change one, change all three.

import { hashString, mix32 } from './rng';

export const EXPERIMENT_ID = 'card-ab-v1';

export const CARD_VARIANTS = ['dare', 'board'] as const;
export type CardVariant = (typeof CARD_VARIANTS)[number];

/** 50/50 by device id (= player id, TECH_SPEC §3.2). Storage-free and stable.
 *  The Rival Ladder's rollout gate (§4bis.21) uses the same two hashes under a
 *  different salt, which makes the two assignments independent. */
export function cardVariantFor(playerId: string): CardVariant {
  return (mix32(hashString(`${EXPERIMENT_ID}:${playerId}`)) & 1) === 0 ? 'dare' : 'board';
}

/**
 * The share URL: `/r/<code>?v=<arm>` and nothing else. `?c=` is reserved for
 * hand-posted seed links (design §10.4) and is never added here — a reshared
 * link must not inherit a channel tag it did not come from.
 *
 * The share TEXT is deliberately identical in both arms: the experiment has one
 * variable, the card.
 */
export function shareUrlFor(origin: string, shareCode: string, playerId: string): string {
  return `${origin}/r/${shareCode}?v=${cardVariantFor(playerId)}`;
}
